import { EcsResponse } from "./helpers/EcsHelper";

export default class Config {
    
    public static ecs: EcsResponse;

}